var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("sfe.route.fdpreport") } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{ pageName, list: ['LIST'] }",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              {
                staticClass: "searchForm",
                attrs: {
                  model: _vm.searchVal,
                  size: "small",
                  inline: "",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("sfe.fdpreport.input.retailerId") },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.retailerId },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "retailerId", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.fdpreport.input.retailerName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.retailerName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "retailerName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("sfe.fdpreport.input.orderNo") } },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.orderNo },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "orderNo", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "flexRow",
                    attrs: {
                      label: _vm.$t("sfe.fdpreport.input.orderCreateTime"),
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "startDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.createDateStart,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.startPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "createDateStart",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "endDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.createDateEnd,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.endPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "createDateEnd",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "flexRow",
                    attrs: {
                      label: _vm.$t("sfe.fdpreport.input.receivedTime"),
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "startDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.receivedTimeStart,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.receivedStartPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "receivedTimeStart",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "endDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.receivedTimeEnd,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.receivedEndPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "receivedTimeEnd",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "footer-right" }, slot: "footer-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.resetData },
              },
              [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                staticClass: "t-search-btn",
                attrs: { size: "small", icon: "el-icon-search" },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "sku",
                  label: _vm.$t("sfe.fdpreport.table.sku"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "b2bName",
                  label: _vm.$t("sfe.fdpreport.table.b2bName"),
                  "min-width": "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireStatus",
                  label: _vm.$t("sfe.fdpreport.table.tireStatus"),
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: _vm.$t("sfe.fdpreport.table.orderNo"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderType",
                  label: _vm.$t("sfe.fdpreport.table.orderType"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerId",
                  label: _vm.$t("sfe.fdpreport.table.retailerId"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerName",
                  label: _vm.$t("sfe.fdpreport.table.retailerName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "consigneeRetailerName",
                  label: _vm.$t("sfe.fdpreport.table.consigneeRetailerName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "consigneeAddress",
                  label: _vm.$t("sfe.fdpreport.table.consigneeAddress"),
                  "min-width": "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stockoutDistance",
                  label: _vm.$t("sfe.fdpreport.table.stockoutDistance"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerStoreAddress",
                  label: _vm.$t("sfe.fdpreport.table.retailerStoreAddress"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pickedupDistance",
                  label: _vm.$t("sfe.fdpreport.table.pickedupDistance"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "photoDistance",
                  label: _vm.$t("sfe.fdpreport.table.photoDistance"),
                  "min-width": "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryDistance",
                  label: _vm.$t("sfe.fdpreport.table.deliveryDistance"),
                  "min-width": "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "photoToDeliveryDistance",
                  label: _vm.$t("sfe.fdpreport.table.photoToDeliveryDistance"),
                  "min-width": "250",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditScore",
                  label: _vm.$t("sfe.fdpreport.table.auditScore"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditRemark",
                  label: _vm.$t("sfe.fdpreport.table.auditRemark"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryDuration",
                  label: _vm.$t("sfe.fdpreport.table.deliveryDuration"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "overDueFlag",
                  label: _vm.$t("sfe.fdpreport.table.overDueFlag"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: _vm.$t("sfe.fdpreport.table.nickname"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createDate",
                  label: _vm.$t("sfe.fdpreport.table.createDate"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stockoutTime",
                  label: _vm.$t("sfe.fdpreport.table.stockoutTime"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pickedupTime",
                  label: _vm.$t("sfe.fdpreport.table.pickedupTime"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryTime",
                  label: _vm.$t("sfe.fdpreport.table.deliveryTime"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "returnTime",
                  label: _vm.$t("sfe.fdpreport.table.returnTime"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receivedTime",
                  label: _vm.$t("sfe.fdpreport.table.receivedTime"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }